import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f2ff853"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Не выбрано", -1))
const _hoisted_4 = { value: -1 }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-12 col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Все", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-12 col-md-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Все", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-12 col-md-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Все", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-12 col-md-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Месяц", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-12 col-md-2" }
const _hoisted_19 = { class: "overflow-hidden" }
const _hoisted_20 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"650px"}
}
const _hoisted_21 = { class: "table table-bordered" }
const _hoisted_22 = { class: "sticky-top bg-white" }
const _hoisted_23 = { class: "position-relative border-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "ФИО", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Должность", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Итого", -1))
const _hoisted_27 = { class: "p-2" }
const _hoisted_28 = { class: "p-2" }
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["colspan"]

import { watch, reactive, computed, onMounted, ref } from 'vue';
import moment from 'moment-timezone';
import api from '@/api';
import { IUnknownObject } from '@/@types/common';
import PopoverUi from '@/components/ui/PopoverUi.vue';
import { ISupplier } from '@/@types/ISupplier';
import { IDepartment } from '@/@types/ISubdivision';
import { IUser } from '@/@types/IUser';

type reportType = {
    id: number;
    name: string;
    post: string;
    orgName: string;
    workedHoursInMonth: { hours: number; details: IUnknownObject; status: string }[];
    totalByMonth: number;
};

type organizationType = {
    id: number;
    name: string;
};

type reportCardStateType = {
    date: string | Date;
    reports: reportType[];
    organizations: organizationType[];
    suppliers: Array<ISupplier>;
    chosenOrganizationId: number;
    supplierId?: number;
    month: number;
    year: number;
    chosenPlot: string;
    chosenAuthorId: number | string;
    depo: {
        name?: string;
        id?: number;
        info?: string;
    };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportCardComponent',
  setup(__props) {

moment.locale('ru');

const state: reportCardStateType = reactive({
    date: new Date(),
    organizations: [],
    suppliers: [],
    reports: [],
    supplierId: -1,
    chosenAuthorId: '',
    chosenOrganizationId: 0,
    month: moment().month(),
    year: moment().year(),
    chosenPlot: '',
    depo: {},
});

function handlePdfDownload() {
    api.employees
        .getReportCardPdf({
            month: state.month,
            year: state.year,
            chosenOrganizationId: state.chosenOrganizationId,
            ...(!!state.chosenPlot && {
                chosenPlot: state.chosenPlot,
            }),
        })
        .then((response) => {
            const headerContentDisp = response.headers['content-disposition'];
            const filename = headerContentDisp?.split('filename=')[1].replace(/["']/g, '');
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: response.headers['content-type'] || 'text/xlsx',
                }),
            );
            const link = document.createElement('a');
            link.setAttribute('download', filename || 'someFile.xlsx');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            link.remove();
        });
}

function getReportCard() {
    return api.employees
        .getReportCard({
            month: state.month,
            year: state.year,
            chosenOrganizationId: state.chosenOrganizationId,
            ...(!!state.chosenPlot && {
                chosenPlot: state.chosenPlot,
            }),
        })
        .then(({ data }) => {
            state.reports = data.reportCard;
            state.depo = data.depo;
            users.value = data.authors;
        });
}

const months = computed(() => moment.months());
const departments = ref<IDepartment[]>([]);
const users = ref<IUser[]>([]);

const daysInMonth = computed(() => {
    return Array.from(
        { length: moment().set({ month: state.month, year: state.year }).daysInMonth() },
        (x, i) => i + 1,
    );
});

const isWeekend = computed(() => (date: number) => {
    return [6, 7].includes(moment().set({ month: state.month, year: state.year, date }).isoWeekday());
});

onMounted(() => {
    getReportCard();
    api.department.get().then((r: any) => {
        departments.value = r.data;
    });
    api.organizations.get().then(({ data }) => {
        if (!data.length) {
            return;
        }
        state.organizations = data;
    });
    api.employees.getEmployeeSupplier().then((res) => {
        if (!res.data.length) {
            return;
        }
        state.suppliers = res.data;
    });
});

watch(
    () => [
        state.month,
        state.year,
        state.chosenOrganizationId,
        state.supplierId,
        state.chosenPlot,
        state.chosenAuthorId,
    ],
    (v: any) => {
        if (typeof state.month !== 'number' || !state.year) {
            return;
        }
        api.employees
            .getReportCard({
                month: state.month,
                year: state.year,
                chosenOrganizationId: state.chosenOrganizationId,
                ...(!!state.chosenPlot && {
                    chosenPlot: state.chosenPlot,
                }),
                ...(!!state.chosenAuthorId && {
                    chosenAuthorId: state.chosenAuthorId,
                }),
                ...(!!state.supplierId && {
                    supplierId: state.supplierId,
                }),
            })
            .then(({ data }) => {
                state.reports = data.reportCard;
                state.depo = data.depo;
                users.value = data.authors;
            });
    },
);

return (_ctx: any,_cache: any) => {
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_form_group_ui, {
          class: "me-2",
          label: "Юр лицо"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.supplierId) = $event)),
              class: "form-select"
            }, [
              _hoisted_3,
              _createElementVNode("option", _hoisted_4, _toDisplayString(state.depo?.info || 'Депо'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.suppliers, (supplier) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: supplier.id,
                  value: supplier.id
                }, _toDisplayString(supplier.name), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, state.supplierId]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (state.organizations.length)
          ? (_openBlock(), _createBlock(_component_form_group_ui, {
              key: 0,
              class: "me-2",
              label: "Основание"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.chosenOrganizationId) = $event)),
                  class: "form-select"
                }, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.organizations, (organization) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: organization.id,
                      value: organization.id
                    }, _toDisplayString(organization.name), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, state.chosenOrganizationId]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_form_group_ui, {
          class: "me-2",
          label: "Подразделение"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.chosenPlot) = $event)),
              class: "form-select"
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departments.value, (plot) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: plot.id,
                  value: plot.realName
                }, _toDisplayString(plot.name), 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, state.chosenPlot]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_form_group_ui, {
          class: "me-2",
          label: "Автор"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.chosenAuthorId) = $event)),
              class: "form-select"
            }, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: user.id,
                  value: user.id
                }, _toDisplayString(user.login), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, state.chosenAuthorId]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_form_group_ui, {
          class: "me-2",
          label: "Месяц"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.month) = $event)),
              class: "form-select"
            }, [
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, monthIdx) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: month,
                  value: monthIdx
                }, _toDisplayString(month), 9, _hoisted_17))
              }), 128))
            ], 512), [
              [_vModelSelect, state.month]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_form_group_ui, { label: "Год" }, {
          default: _withCtx(() => [
            _createVNode(_component_input_ui, {
              modelValue: state.year,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.year) = $event)),
              mask: { mask: 'Z*', tokens: { Z: { pattern: /[0-9]/ } } },
              maxlength: "4",
              placeholder: "Год"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("thead", _hoisted_22, [
              _createElementVNode("tr", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysInMonth.value, (date) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: date,
                    class: _normalizeClass(["p-2", { 'bg-light': isWeekend.value(date) }])
                  }, _toDisplayString(date), 3))
                }), 128)),
                _hoisted_26
              ])
            ]),
            _createElementVNode("tbody", null, [
              (state.reports.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.reports, (employee) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: employee.id
                    }, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(employee.name), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(employee.post), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employee.workedHoursInMonth, ({ details, hours, status }, date) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: date,
                          class: _normalizeClass(["p-2", { 'bg-light': isWeekend.value(date + 1) }])
                        }, [
                          (!!hours || !!status)
                            ? (_openBlock(), _createBlock(PopoverUi, {
                                key: 0,
                                class: "border-0 m-0",
                                content: 
                                                Object.keys(details).reduce(
                                                    (acc, key) => acc + `${key}: ${details[key]}<br />`,
                                                    '',
                                                )
                                            
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(status ? status : hours), 1)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128)),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(employee.totalByMonth), 1)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _createElementVNode("td", {
                      class: "py-5 text-center",
                      colspan: 3 + daysInMonth.value.length
                    }, "Отсутствуют данные", 8, _hoisted_31)
                  ]))
            ])
          ]),
          _createVNode(_component_button_ui, {
            "button-class": "btn-outline-success ms-3 sticky-bottom",
            onClick: handlePdfDownload
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Экспорт в Excel ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}
}

})